import { render, staticRenderFns } from "./couponPackageManage.vue?vue&type=template&id=24d0bae7&"
import script from "./couponPackageManage.vue?vue&type=script&lang=js&"
export * from "./couponPackageManage.vue?vue&type=script&lang=js&"
import style0 from "./couponPackageManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports